import { compose, merge, pick, prop } from 'ramda';
import React from 'react';
import $ from 'jquery';
import autoBind from '../../modules/autoBind';
import { validations } from 'common';
import DatePicker from 'react-date-picker';
import NumberInput from '../../modules/numberInput.jsx';

export default class PersonalDataForm extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = { showingDatepicker: false };
  }
  componentDidMount() {
    $(document).mouseup((event) => {
      const datepicker = $('#datepicker');
      const datepickerButton = $('#datepicker-button');
      if (!datepicker.is(event.target) && !datepickerButton.is(event.target) && datepicker.has(event.target).length === 0 && datepickerButton.has(event.target).length === 0) {
        this.setState({ showingDatepicker: false });
        event.stopPropagation();
      }
    });
  }
  componentWillUnmount() {
    $(document).off('mouseup');
  }
  render() {
    const nameInput = <input type='text' onChange={this.handleChange('name')} value={this.props.value.name}></input>;
    const companyInput = <input type='text' onChange={this.handleChange('company')} value={this.props.value.company}></input>;
    const ageInput = <NumberInput value={this.props.value.age} onChange={this.handleChange('age')} min="0" max="125" />;
    const datePicker = (
      <div>
        <button id='datepicker-button' type='button' onClick={this.toggleDatePicker} className='btn btn-sm btn-default'>{this.props.value.date.format('DD/MM/YYYY')}</button>
      </div>
    );

    return (
      <form style={{ marginBottom: '10px' }}>
        {this.renderField('Nombre:', nameInput)}
        {this.renderField('Empresa:', companyInput)}
        {this.renderField('Fecha:', datePicker)}
        <div id='datepicker'>
          <If condition={this.state.showingDatepicker}>
            <DatePicker minDate='2010-01-01' maxDate='2050-01-01' date={this.props.value.date} onChange={compose(this.toggleDatePicker, this.handleChange('date'))} locale='es-MX'/>
          </If>
        </div>
        {this.renderField('Edad:', ageInput)}
      </form>
    );
  }
  toggleDatePicker() {
    this.setState({ showingDatepicker: !this.state.showingDatepicker });
  }
  renderField(label, input) {
    return (
      <div className='row form-inline' style={{ 'marginBottom': '10px' }}>
        <div className='col-xs-4'>
          <label>{label}</label>
        </div>
        <div className='col-xs-8'>
          {input}
        </div>
      </div>
    );
  }
  handleChange(fieldId) {
    return (event, moment) => {
      const value = fieldId === 'age' ? event : fieldId === 'date' ? moment : event.target.value;
      const newFormValue = merge(this.props.value, { [fieldId]: value }) 
      this.props.onChange(merge(newFormValue, { valid: PersonalDataForm.validForm(newFormValue) }));
    };
  }
  static validForm(value) {
    const formValidations = merge(pick(['name', 'company', 'age'], validations), { date: prop('_isAMomentObject') });
    return validations.validateObject(formValidations, value);
  }
}



// WEBPACK FOOTER //
// ./src/App/reports/PersonalDataForm.jsx